// @flow
import * as React from 'react';
import { StyleSheet } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import theme from '../../../theme-config';
import I18n from '../../../lib/i18n';
import FormatService from '../../../lib/format';
import type { Periodicity } from 'digicel-kaizen-library';
import formatPeriodicity from '../../../lib/TripicaPeriodicityFormatter';

const CharacteristicSliderPrice = (props: Props) => {
  const styles = getStyles();
  const formattedPeriodicity = props.periodicity ? formatPeriodicity(props.periodicity) : '';
  const fullPrice = isNaN(props.price)
    ? I18n.t(`PRICE_${props.price}`)
    : `+${FormatService.formatCentsToCurrency(props.price, true) + formattedPeriodicity}`;

  const displayedText = props.showIncludedTextInsteadOfPrice ? I18n.t('hasOnlyOneFreeChoice.included') : fullPrice;

  return <Text style={[styles.price, props.lightColors && styles.lightPrice]}>{displayedText}</Text>;
};

const getStyles = () =>
  StyleSheet.create({
    price: {
      color: theme.primaryColor,
      fontSize: 18,
    },
    lightPrice: {
      color: theme.overPrimaryColor,
    },
  });

type Props = {
  showIncludedTextInsteadOfPrice: boolean,
  currency: string,
  price: any,
  periodicity: Periodicity,
  lightColors?: boolean,
};

export default CharacteristicSliderPrice;
